var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"backpack vibration",on:{"click":_vm.showSchoolTestModal}})}
var staticRenderFns = []

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib??vue-loader-options!./src/templates/components/base/header/school-test/components/backpack-btn.vue?vue&type=template&id=40b70621&
// module id = 1305
// module chunks = 0